<script setup>
const route = useRoute()
</script>

<template>
  <div data-theme="light" class="min-h-screen bg-base-200">
    <div class="shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1)]">
      <NavAppHeader />
    </div>
    <div class="py-2">
      <slot />
    </div>
    <NavCartButton v-if="route.path !== '/cart'" />
    <NavAppFooter />
  </div>
</template>

<style scoped></style>
